import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [status, setStatus] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		setStatus(item.isBlocked);
	}, [item]);

	return (
		<tr key={index} className="text-center">
			<td>{item?.username || "-"}</td>
			<td>{item?.email || "-"}</td>
			<td>
				{item?.country_code || ""} {item?.phone || "-"}
			</td>
			{/* <td>{item.count_orders || '-'}</td> */}
			<td>
				<Form.Check
					type="switch"
					id={`custom-switch${index}`}
					checked={!status}
					// onChange={(e)=> changeStatusToggle(e)}
				/>
			</td>
			{/* <td>
                      <Form.Check
                        type="switch"
                        id={`isDeleted${index}`}
                        checked={item.isDeleted}
                        // onChange={(e)=> changeStatusToggle(e)}
                      />
                    </td> */}
			{/* <td>
                     {isExist('users') && <Dropdown>
                        <Dropdown.Toggle
                          // variant="success"
                          className="light sharp i-false"
                        >
                          <i className="la la-ellipsis-v" style={{fontSize: '27px'}}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                           <Dropdown.Item>Edit</Dropdown.Item> 
                          <Dropdown.Item>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>}
                    </td> */}
		</tr>
	);
};
export default CardItem;
